import React, { useState } from "react";
import MuiButton from "Components/MuiButton/MuiButton";
import Translator from "Languages/Utility/Translator";
import Dialog from "@material-ui/core/Dialog";
import { useTheme } from '@material-ui/core/styles';
import { read } from "Helpers/LocalStorage";
import UserService from "Services/http/endpoints/user/UserService";
import StatusHandler from "Helpers/StatusHandler";
import { useSetState } from "Helpers/Hooks";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import MuiAutoComplete from "Components/MuiAutoComplete/MuiAutoComplete";
import MuiSkeleton from "Components/MuiSkeleton/MuiSkeleton";
import TransferUser from "./components/TransferUser";
import {DialogActions, Divider} from "@material-ui/core";
import showNotify from "Helpers/Notify";
import { useTranslation } from 'react-i18next';

function ManageUserSupervisor() {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const [openDialog, setOpenDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [groupedAgents, setGroupedAgents] = useState(null);
  const [unGroupedAgents, setUnGroupedAgents] = useState(null);

  const [controls, setControls] = useSetState({
    superVisor: {
      type: "select",
      selectItems: [],
      value: null,
      validation: null,
    },
    agent: {
      type: "select",
      selectItems: [],
      value: null,
      validation: null,
    },
  });

  const handleDialog = () => {
    setOpenDialog(!openDialog);
  };

  const autoCompleteHandler = async (e, value) => {
    const controlName = e.target.id.split("-")[0];
    setControls({ [controlName]: { value: value } });
    if (controlName === "superVisor") {
      const params = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        KeySuperVisor: value.Key,
      };
      const response = await UserService.getAgentData(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const data = response.data.Value;
        const update = data.map((item) => {
          return {
            ...item,
            value: item.UserName,
            label: item.DisplayName,
            key: item.IdUser,
          };
        });
        setControls({ agent: { selectItems: update } });
      }
      const responseGrouped = await UserService.getGroupedAgents(params);
      let errGrouped = StatusHandler(responseGrouped);
      if (!errGrouped.isFail) {
        setGroupedAgents(responseGrouped.data.Value);
      }
      const responseUnGrouped = await UserService.getUnGroupedAgents(params);
      let errUnGrouped = StatusHandler(responseUnGrouped);
      if (!errUnGrouped.isFail) {
        setUnGroupedAgents(responseUnGrouped.data.Value);
      }
    }
  };

  const setValue = (name, value) => {
    setControls({ [name]: { value: value } });
  };

  const onSubmit = async () => {
    const { superVisor, agent } = controls;
         try {
        setLoading(true);
        const data = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          KeySuperVisor: superVisor.value.Key,
          KeyAgent: agent.value.Key,
        };
        const response = await UserService.postTransferAgentSupervisor(data);
        let err = StatusHandler(response);
        if (!err.isFail) {
          showNotify({
            text: t('mission_accomplished'),
            customClass: "success",
          });
        }
        handleDialog()
        setLoading(false);
      } catch (e) {
           setLoading(false);
      }
  };


  const onEnter = async () => {
    onClear();
    try {
      setLoading(true);
      const params = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
      };
      const response = await UserService.getSupervisorData(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const data = response.data.Value;
        const update = data.map((item) => {
          return {
            ...item,
            value: item.UserName,
            label: item.DisplayName,
          };
        });
        setControls({ superVisor: { selectItems: update } });
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  const onClear = () => {
    setControls({ superVisor: { value: null } });
    setControls({ selectItems: { value: [] } });
    setControls({ agent: { value: null } });
    setControls({ agent: { value: [] } });
    setGroupedAgents(null);
    setUnGroupedAgents(null);
  };

  return (
    <>
      <MuiButton
        loading={loading}
        color="secondary"
        title={<Translator id="Manage_User_Supervisor" />}
        onClick={handleDialog}
      />
      <Dialog
        dir={direction}
        open={openDialog}
        onEnter={onEnter}
        onClose={handleDialog}
        fullWidth
        maxWidth="md"
      >
        <div className="dialogHeader">
          <p> {<Translator id="Manage_User_Supervisor" />} </p>
        </div>
        <DialogContent>
          {!loading ? (
            <Grid container spacing={2}>
              <Grid item sm={6} xs={12}>
                <MuiAutoComplete
                  setValue={setValue.bind(this)}
                  loading={loading}
                  options={controls.superVisor.selectItems}
                  label={<Translator id={"superVisor"} />}
                  value={controls.superVisor.value}
                  id={"superVisor"}
                  onChange={autoCompleteHandler}
                />
              </Grid>
              <Grid item xs={6} />
              {
                controls.superVisor.value &&
                <>
                  <Grid item xs={12} className="mb-2">
                    <TransferUser
                      groupedAgents={groupedAgents}
                      unGroupedAgents={unGroupedAgents}
                      superVisorKey={controls.superVisor.value.Key}
                    />
                  </Grid>
                  <Divider />
                  <Grid item xs={12}>
                    <p className={"text-right my-1"}>
                      <b> {<Translator id="User_Supervisor_Replace" />}</b>
                      <span className="mx-1">
                        {controls.superVisor.value.label}
                      </span>
                    </p>
                  </Grid>
                  <Grid item sm={6} xs={12}>
                    <MuiAutoComplete
                      setValue={setValue.bind(this)}
                      loading={loading}
                      options={controls.agent.selectItems}
                      label={<Translator id={"agent"} />}
                      value={controls.agent.value}
                      id={"agent"}
                      onChange={autoCompleteHandler}
                    />
                  </Grid>
                </>
              }
            </Grid>
          ) : (
            <MuiSkeleton xs={12} number={6} />
          )}
        </DialogContent>
        <DialogActions>
          {
            controls.superVisor.value &&
            <MuiButton
              loading={loading}
              color="primary"
              title={<Translator id="zakhire" />}
              onClick={onSubmit}
            />
          }
          <MuiButton
              onClick={handleDialog}
              title={<Translator id="enseraf" />}
          />
        </DialogActions>
      </Dialog>
    </>
  );
}

export default ManageUserSupervisor;
